

/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */

// @mui material components
import Grid from "@mui/material/Grid";

import MDBox from "components/MDBox";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";

import { useSelector,useDispatch } from "react-redux";
import { useEffect } from "react";
import { getDashboard } from "Redux/actions/user";
import bkash from "assets/images/icons/BKash_Logo_icon 1.svg";
import nagad from "assets/images/icons/nagad.svg";
import cash from "assets/images/icons/tholi.svg";
import bank from "assets/images/icons/nbl.svg";
import total from "assets/images/icons/tk logo.svg";
import transaction from "assets/images/icons/transaction.svg"


function Dashboard() {
const dispatch=useDispatch();
useEffect(()=>{
  dispatch(getDashboard());
},[dispatch])
const {dashboard}=useSelector(state=>state.user);
// console.log(dashboard)
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox >
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox >
              <ComplexStatisticsCard
                color="dark"
                icon={total}
                title="Total"
                count={dashboard?.total}
                // percentage={{
                //   color: "success",
                //   amount: "+55%",
                //   label: "than lask week",
                // }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox >
              <ComplexStatisticsCard
              color="primary"
                icon={bkash}
                title="bKash"
                count={dashboard?.bkash}
                // percentage={{
                //   color: "success",
                //   amount: "+3%",
                //   label: "than last month",
                // }}
              />
            </MDBox>
          </Grid>
          
        </Grid>
        <Grid container spacing={3} mt={2}>
        <Grid item xs={12} md={6} lg={6}>
            <MDBox >
              <ComplexStatisticsCard
                color="nagad"
                icon={nagad}
                title="Nagad"
                count={dashboard?.nagad}
                // percentage={{
                //   color: "success",
                //   amount: "+1%",
                //   label: "than yesterday",
                // }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox>
              <ComplexStatisticsCard
                // color="pr"
                icon={cash}
                action="cash"
                title="Cash"
                button="true"
                buttonColor="info"
                count={dashboard?.cash}
                // percentage={{
                //   color: "success",
                //   amount: "",
                //   label: "Just updated",
                // }}
              />
            </MDBox>
          </Grid>
          
        </Grid>
        <Grid container spacing={3} mt={2}>
        <Grid item xs={12} md={6} lg={6}>
            <MDBox >
              <ComplexStatisticsCard
                color="success"
                icon={bank}
                title="Bank"
                count={dashboard?.bank}
                button="true"
                buttonColor="success"
                action="bank"
                // percentage={{
                //   color: "success",
                //   amount: "+1%",
                //   label: "than yesterday",
                // }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox >
              <ComplexStatisticsCard
                color="dark"
                icon={transaction}
                title="Transaction"
                count={dashboard?.transaction}
                // percentage={{
                //   color: "success",
                //   amount: "",
                //   label: "Just updated",
                // }}
              />
            </MDBox>
          </Grid>
          
        </Grid>
        
      </MDBox>
    </DashboardLayout>
  );
}

export default Dashboard;
